import { createFileRoute, redirect } from "@tanstack/react-router"
import { api, type AdminUser } from "@/lib/api"
import { AdminShell } from "@/components/admin-shell"

export const Route = createFileRoute("/admin/_authed")({
  beforeLoad: async ({ context }) => {
    const cached = context.queryClient.getQueryData<AdminUser | null>(["auth", "me"])
    if (cached) return

    try {
      await context.queryClient.fetchQuery({
        queryKey: ["auth", "me"],
        queryFn: async () => (await api.get<AdminUser>("/auth/me")).data,
      })
    } catch {
      throw redirect({ to: "/admin/login" })
    }
  },
  component: AdminShell,
})
